export * from './ActiveIngredientText';
